/**
 * example:
 * {
	"messageType": "alertNotification",
	"notificationId": 1645475715800,
	"notificationDetails": {"updateType":"SETUP_TRIGGERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_TRIGGERED",
	"statusDetails": {"pluginTemplate":{"bouncePrice":100.0},"triggerPrice":100.0,"tradeDirection":"LONG","tacticName":"BOUNCE","symbol":"XYZ"},
	"date": "2022-02-21T15:35:16.290-0500",
	"timestamp": "1645475716292"
}

 * @param {*} pluginTemplate 
 * @returns object with fields:
 * 1) bouncePrice
 */
export function bounceParser(pluginTemplate) {
    const parsedObject = {
        bouncePrice: null
    }
    if(pluginTemplate) {
        parsedObject.bouncePrice=pluginTemplate.bouncePrice;
    }
    return parsedObject;
}